import React, { useState, useRef, useEffect } from "react";
import ModalEditPhoto from "./modals/ModalEditPhoto";
import { v4 as uuid } from "uuid";
import {
  updateSignature,
  dataLookUpConst,
  getAllCards,
  getESLookUp,
  uploadImage,
  validateDataSignature,
} from "../constants";
import { QRCode } from "react-qrcode-logo";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bottom_left, bottom_right, top_left, top_right } from "../assets";
import Signature from "./Signature.jsx";
import { toPng } from "html-to-image";

const UpdateSignature = ({ data_ }) => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(data_.name);
  const [data, setData] = useState(data_.card);
  const [slug, setSlug] = useState(data_.card.slug);
  const [jobPosition, setJobPosition] = useState(data_.card.job_title);
  const [showError, setShowError] = useState(false);
  const [errrorMsg, setErrorMsg] = useState("");
  const [cards, setCards] = useState([]);
  const [prefix, setPrefix] = useState(data_.card.prefix);
  const [firstName, setFirstName] = useState(data_.card.first_name);
  const [middleName, setMiddleName] = useState(data_.card.middle_name);
  const [lastName, setLastName] = useState(data_.card.last_name);
  const [suffix, setSuffix] = useState(data_.card.suffix);

  const imageRef = useRef(null);
  const [templateIndex, setTemplateIndex] = useState(
    ["default", "no_image", "no_qr"].indexOf(data_.template.label),
  );
  const setTemplate = (e, ind) => {
    e.preventDefault();
    setTemplateIndex(ind);
  };

  const [dataLookup, setDataLookup] = useState(dataLookUpConst);
  const [indexCard, setIndexCard] = useState(0);
  const token = user.access_token;
  const navigate = useNavigate();

  const handleOnClickUpdateSignature = async (e) => {
    e.preventDefault();
    setLoading(true);
    let image = await toPng(imageRef.current, {
      cacheBust: true,
      skipFonts: true,
      width: 700,
    });
    let dataJson = {
      card_id: data.card_id,
      name: name,
      template_id: styles[templateIndex].lookup_id,
    };
    const es_image_id = await uploadImage(token, image, "email_signature");
    dataJson.image_id = es_image_id;
    let err = validateDataSignature(dataJson);
    if (err != "") {
      toast.error(err, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
      return;
    }

    updateSignature(
      token,
      data_.email_sg_id,
      dataJson,
      setLoading,
      setShowError,
      setErrorMsg,
      navigate,
    );
  };

  useEffect(() => {
    const msg = localStorage.getItem("toastMsg", "");
    getAllCards(token, setCards);
    getESLookUp(token, setStyles);
    if (Boolean(msg)) {
      localStorage.removeItem("toastMsg");
      toast.success(msg, {
        position: "top-center",
        autoClose: 3000,
      });
    }
  }, []);

  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [showError]);
  const handleOnChangeTitle = (e) => {
    e.preventDefault();
    setName(e.target.value);
  };

  const [styles, setStyles] = useState([
    {
      lookup_id: "LKPa15292169ac04e75a6bf29715dff8604",
      category: "email_signature",
      label: "default",
      display_label: "Default",
      base_url: null,
      placeholder: null,
      type: null,
      values: null,
      image_id: "IMG028efeb64f9f4e128b96025834cda2a9",
      image_url:
        "https://cdn.nitomeyocard.com/asset/IMG028efeb64f9f4e128b96025834cda2a9.jpeg",
      created_at: "2025-12-21T14:11:01.441308+00:00",
      updated_at: "2025-12-21T14:11:01.441308+00:00",
    },
    {
      lookup_id: "LKP7e1c3023992748c1b0e687c4ffbe5609",
      category: "email_signature",
      label: "no_image",
      display_label: "No Image",
      base_url: null,
      placeholder: null,
      type: null,
      values: null,
      image_id: "IMG395f188983ea428a8fa7de4c0fecd949",
      image_url:
        "https://cdn.nitomeyocard.com/asset/IMG395f188983ea428a8fa7de4c0fecd949.jpeg",
      created_at: "2025-12-21T14:11:03.314617+00:00",
      updated_at: "2025-12-21T14:11:03.314617+00:00",
    },
    {
      lookup_id: "LKPb15c87d6c35c49039f1111daf408cbc2",
      category: "email_signature",
      label: "no_qr",
      display_label: "No QR",
      base_url: null,
      placeholder: null,
      type: null,
      values: null,
      image_id: "IMG0dfce07d1279441093feec082b07f954",
      image_url:
        "https://cdn.nitomeyocard.com/asset/IMG0dfce07d1279441093feec082b07f954.jpeg",
      created_at: "2025-12-21T14:11:05.294852+00:00",
      updated_at: "2025-12-21T14:11:05.294852+00:00",
    },
  ]);

  useEffect(() => {
    if (cards.length > 0) {
      setIndexCard(() => {
        return cards.map((val) => val.card_id).indexOf(data.card_id);
      });
    }
  }, [cards]);

  useEffect(() => {
    if (cards.length > 0) {
      setData({ ...cards[indexCard], name: cards[indexCard].card_name });
    }
  }, [indexCard]);

  useEffect(() => {
    if (Object.keys(data).length != 0) {
      setPrefix(data.prefix);
      setFirstName(data.first_name);
      setMiddleName(data.middle_name);
      setLastName(data.last_name);
      setSuffix(data.suffix);
      setJobPosition(data.job_title);
      setSlug(data.slug);
    }
  }, [data]);

  return (
    <div className="flex flex-col md:flex-row w-full bg-white h-full overflow-y-auto md:overflow-y-hidden">
      <ToastContainer />
      <div className="flex flex-col border-0 border-r-2 border-r-gray-200 w-full md:w-1/2 px-5 py-5 gap-3 justify-center items-center md:overflow-y-hidden">
        <div className="flex flex-col relative w-full bg-white overflow-x-hidden overflow-x-clip">
          <div className="absolute left-[9999999px]">
            <Signature
              ref_={imageRef}
              isFix={true}
              type={templateIndex}
              name={
                data.first_name
                  ? data.first_name.split()[0] + " " + data.last_name
                  : null
              }
              jobPosition={data.job_title}
              profilePicture={data.profile_image_url}
              companyLogo={data.logo_image_url}
              email_val={
                data.first_name &&
                data.card_social.filter(
                  (val) =>
                    val.lookup_id == "LKP8d00ffb749ce4cb4a26236888b7614e2",
                ).length > 0
                  ? data.card_social.filter(
                      (val) =>
                        val.lookup_id == "LKP8d00ffb749ce4cb4a26236888b7614e2",
                    )[0].input_value
                  : null
              }
              whatsapp_val={
                data.first_name &&
                data.card_social.filter(
                  (val) =>
                    val.lookup_id == "LKP7867fa015b0240f3a7f06ad0d76a5021",
                ).length > 0
                  ? data.card_social.filter(
                      (val) =>
                        val.lookup_id == "LKP7867fa015b0240f3a7f06ad0d76a5021",
                    )[0].input_value
                  : null
              }
              address_val={
                data.first_name &&
                data.card_social.filter(
                  (val) =>
                    val.lookup_id == "LKPe0c77ceb40aa4054bf16a9221752acd8",
                ).length > 0
                  ? data.card_social.filter(
                      (val) =>
                        val.lookup_id == "LKPe0c77ceb40aa4054bf16a9221752acd8",
                    )[0].input_value
                  : null
              }
              extraLogo={
                data.first_name &&
                data.card_social
                  .filter(
                    (val) =>
                      ![
                        "LKP8d00ffb749ce4cb4a26236888b7614e2",
                        "LKP7867fa015b0240f3a7f06ad0d76a5021",
                        "LKPe0c77ceb40aa4054bf16a9221752acd8",
                      ].includes(val.lookup_id),
                  )
                  .map((val) => val.icon_image_url)
              }
              slug={data.slug}
            />
          </div>
          <Signature
            type={templateIndex}
            name={
              data.first_name
                ? data.first_name.split()[0] + " " + data.last_name
                : null
            }
            jobPosition={data.job_title}
            profilePicture={data.profile_image_url}
            companyLogo={data.logo_image_url}
            email_val={
              data.first_name &&
              data.card_social.filter(
                (val) => val.lookup_id == "LKP8d00ffb749ce4cb4a26236888b7614e2",
              ).length > 0
                ? data.card_social.filter(
                    (val) =>
                      val.lookup_id == "LKP8d00ffb749ce4cb4a26236888b7614e2",
                  )[0].input_value
                : null
            }
            whatsapp_val={
              data.first_name &&
              data.card_social.filter(
                (val) => val.lookup_id == "LKP7867fa015b0240f3a7f06ad0d76a5021",
              ).length > 0
                ? data.card_social.filter(
                    (val) =>
                      val.lookup_id == "LKP7867fa015b0240f3a7f06ad0d76a5021",
                  )[0].input_value
                : null
            }
            address_val={
              data.first_name &&
              data.card_social.filter(
                (val) => val.lookup_id == "LKPe0c77ceb40aa4054bf16a9221752acd8",
              ).length > 0
                ? data.card_social.filter(
                    (val) =>
                      val.lookup_id == "LKPe0c77ceb40aa4054bf16a9221752acd8",
                  )[0].input_value
                : null
            }
            extraLogo={
              data.first_name &&
              data.card_social
                .filter(
                  (val) =>
                    ![
                      "LKP8d00ffb749ce4cb4a26236888b7614e2",
                      "LKP7867fa015b0240f3a7f06ad0d76a5021",
                      "LKPe0c77ceb40aa4054bf16a9221752acd8",
                    ].includes(val.lookup_id),
                )
                .map((val) => val.icon_image_url)
            }
            slug={data.slug}
          />
        </div>

        <div
          className="px-10 py-2 bg-primary text-white shadow-lg hover:bg-tertiary active:translate-y-1 cursor-pointer rounded-lg"
          onClick={handleOnClickUpdateSignature}
          id="UpdateSignature"
        >
          {loading ? (
            <div role="status">
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="white"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="#E47410"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Update Signature"
          )}
        </div>
      </div>
      <div className="flex flex-col md:w-1/2 w-full h-full divide-y-[1px] divide-gray-200">
        <div className="flex flex-col w-full justify-start items-start overflow-y-auto h-[83vh]">
          <div className="flex flex-col px-5 pt-5 pb-52 md:py-5 gap-5 w-full overflow-y-auto">
            <div className="flex flex-col">
              <div className="font-bold">Signature Profile</div>
              <div className="text-[14px] text-gray-400">
                These fields do not appear in email signature
              </div>
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-row w-4/12 justify-start items-center gap-3">
                <div>Signature Title</div>
              </div>
              <input
                className={`flex flex-col border border-black bg-gray-200 rounded-lg w-3/4 md:w-1/2 h-[40px] px-3`}
                onChange={handleOnChangeTitle}
                value={name}
                disabled={true}
              />
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-row w-4/12 justify-start items-center gap-3">
                <div>Card</div>
              </div>
              <select
                id="cards"
                className="bg-white border border-gray-400 text-gray-900 rounded-lg focus:outline-blue-500 focus:border-blue-500 block px-3 py-2 w-3/4 md:w-1/2"
                value={indexCard}
                onChange={(e) => setIndexCard(e.target.value)}
              >
                {cards.length > 0 ? (
                  cards.map((val, ind) => (
                    <option key={ind} value={ind}>
                      {val.card_name}
                    </option>
                  ))
                ) : (
                  <option>Card</option>
                )}
              </select>
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-bold">Template</div>
              <div className="grid grid-cols-1 gap-2">
                {styles.map((val, ind) => {
                  return (
                    <div
                      key={ind}
                      className={`flex flex-col w-full items-center ${
                        ind == templateIndex ? "bg-gray-200" : ""
                      } px-2 py-3 gap-3 rounded-md cursor-pointer`}
                      onClick={(e) => setTemplate(e, ind)}
                    >
                      <img src={val.image_url} className="w-[50%]" />
                      <div>{val.display_label}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateSignature;
